import { useState, useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import {
  CategorySubTag,
  CategoryTag,
  ContentMainCard,
  ContentSubCard,
  FilterButtons,
  ImageMainCard,
  ImageSubCard,
  KnowMoreMainCard,
  NewsPageContainer,
  NewsPageFilterRow,
  NewsPageFilterText,
  NewsPageMainCards,
  NewsPageSubCards,
  NewsPageTitle,
  RightPartMainCard,
  StyledArrowIcon,
  TitleMainCard,
  TitleSubCard,
  TwitterTimeLine,
  WrapCards,
  WrapCardsAndTwitter,
  WrapContent,
  WrapGrid,
  WrapKnowMore,
} from "../../styles/NewsPage";
import { NEWS } from "../../core/app-urls";
import { getNews, getNewsPaginated } from "../../data/services/news";
import NewsModel from "../../data/model/news";
import NEWSEXAMPLE from "../../assets/img/newsExample.png";
import { endpoint } from "../../utils/Constants";
import TwitterTimeline from "../../components/TwitterTimeline/TwitterTimeline";

export default function NewsPage() {
  const [newsList, setNewsList] = useState<NewsModel[]>([]);
  const [allNewsList, setAllNewsList] = useState<NewsModel[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalNewsCount, setTotalNewsCount] = useState(0);
  const [selectedFilter, setSelectedFilter] = useState("Todas");

  const newsPerPage = 10;

  useEffect(() => {
    const fetchNews = async () => {
      setLoading(true);
      try {
        const responseAllNews = await getNews();
        setTotalNewsCount(responseAllNews.news.length);

        const start = (currentPage - 1) * newsPerPage;
        const response = await getNewsPaginated(start.toString(), newsPerPage.toString());

        setNewsList(response.news);
      } catch (error) {
        console.error("Erro ao carregar notícias paginadas", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, [currentPage, selectedFilter]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://platform.twitter.com/widgets.js";
    script.async = true;
    script.setAttribute("data-lang", "pt");
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);


  const handleFilterClick = (filter: string) => {
    setSelectedFilter(filter);
    setCurrentPage(1);
  };

  const filteredNewsList =
    selectedFilter === "Todas"
      ? newsList
      : newsList.filter((news) => news.tag === selectedFilter);

  const mainCardsNewsList = filteredNewsList.slice(0, 3);
  const gridNewsList = filteredNewsList.slice(3);
  const totalPages = Math.ceil(totalNewsCount / newsPerPage);

  const Pagination = () => (
    <div style={{ display: "flex", gap: "10px", marginTop: "30px", justifyContent: "center" }}>
      {Array.from({ length: totalPages }, (_, index) => (
        <button
          key={index}
          onClick={() => setCurrentPage(index + 1)}
          style={{
            padding: "8px 12px",
            border: "1px solid #ccc",
            backgroundColor: currentPage === index + 1 ? "#FF8787" : "#fff",
            color: currentPage === index + 1 ? "#fff" : "#000",
            cursor: "pointer",
            borderRadius: "4px",
            height: "50px",
            alignSelf: "self-end"
          }}
        >
          {index + 1}
        </button>
      ))}
    </div>
  );

  return (
    <>
      <Header />
      <NewsPageContainer>
        <WrapContent>
          <NewsPageTitle>Nossas notícias</NewsPageTitle>
          <NewsPageFilterText>
            Clique nos filtros abaixo para ter acesso às notícias do seu interesse.
          </NewsPageFilterText>
          <NewsPageFilterRow>
            {["Todas", "parcerias", "eventos", "BC Saúde", "reuniões"].map((filter) => (
              <FilterButtons
                key={filter}
                onClick={() => handleFilterClick(filter)}
                style={{
                  borderColor: selectedFilter === filter ? getTagColor(filter) : "#fff",
                  color: selectedFilter === filter ? getTagColor(filter) : "#000",
                }}
              >
                {filter.charAt(0).toUpperCase() + filter.slice(1)}
              </FilterButtons>
            ))}
          </NewsPageFilterRow>
        </WrapContent>

        {loading ? (
          <p style={{ textAlign: "center" }}>Carregando notícias...</p>
        ) : (
          <>
            <WrapCardsAndTwitter>
              <WrapCards>
                {mainCardsNewsList.map((news, index) => (
                  <NewsPageMainCards key={index} href={`${NEWS}/${news.id}`}>
                    <ImageMainCard
                      src={`${endpoint}${news.imagem_noticia}` || NEWSEXAMPLE}
                    />
                    <RightPartMainCard>
                      <CategoryTag newColor={getTagColor(news.tag)}>
                        {news.tag}
                      </CategoryTag>
                      <TitleMainCard>{news.titulo}</TitleMainCard>
                      <ContentMainCard>{news.resumo}</ContentMainCard>
                      <WrapKnowMore>
                        <KnowMoreMainCard>Leia a matéria na íntegra</KnowMoreMainCard>
                        <StyledArrowIcon size={23} />
                      </WrapKnowMore>
                    </RightPartMainCard>
                  </NewsPageMainCards>
                ))}
              </WrapCards>
              <TwitterTimeLine>
                {/* <a
                  className="twitter-timeline"
                  href="https://twitter.com/BancoCentralBR?ref_src=twsrc%5Etfw"
                  data-lang="pt"
                >
                  Tweets by BancoCentralBR
                </a> */}
                {/* <iframe src='https://widgets.sociablekit.com/twitter-feed/iframe/25591839' width='100%' height='1000'></iframe> */}
                <iframe src="https://www.juicer.io/api/feeds/bancocentralbr/iframe" width="100%" height="1000" style={{display: "block", margin: "0 auto", padding: "0", border: "none"}}></iframe>
              </TwitterTimeLine>
            </WrapCardsAndTwitter>

            <WrapGrid>
              {gridNewsList.map((news, index) => (
                <NewsPageSubCards key={index} href={`${NEWS}/${news.id}`}>
                  <ImageSubCard src={`${endpoint}${news.imagem_noticia}`} />
                  <RightPartMainCard>
                    <CategorySubTag newColor={getTagColor(news.tag)}>
                      {news.tag}
                    </CategorySubTag>
                    <TitleSubCard>{news.titulo}</TitleSubCard>
                    <ContentSubCard>{news.resumo}</ContentSubCard>
                    <WrapKnowMore>
                      <TitleSubCard>Leia a matéria na íntegra</TitleSubCard>
                      <StyledArrowIcon size={20} />
                    </WrapKnowMore>
                  </RightPartMainCard>
                </NewsPageSubCards>
              ))}
              <Pagination />
            </WrapGrid>

          </>
        )}
      </NewsPageContainer>
      <Footer />
    </>
  );
}

function getTagColor(selectedCategory: string): string {
  switch (selectedCategory) {
    case "parcerias":
      return "#1270B0";
    case "eventos":
      return "#85A261";
    case "BC Saúde":
      return "pink";
    case "Reuniões":
      return "gray";
    default:
      return "";
  }
}

